module.exports = __webpack_public_path__ + "static/media/slideshow (1).68bd89a1.png";